import { globalEndpoints } from "../globalEndpoints";
import { mainApi } from "../mainApi";

const path = "v2/dashboard";
const name = "Dashboard";

export const dashboardApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    ...globalEndpoints(builder, path, name, []),

    getChartData: builder.query({
      query: (params) => {
        return {
          url: `/${path}/chart-data`,
          method: "GET",
          params,
        };
      },
      providesTags: ["DashboardChart"],
    }),

    getDialData: builder.query({
      query: (params) => {
        return {
          url: `/${path}/dial-data`,
          method: "GET",
          params,
        };
      },
      providesTags: ["DashboardDial"],
    }),
    getTableData: builder.query({
      query: (params) => {
        return {
          url: `/${path}/table-data`,
          method: "GET",
          params,
        };
      },
      providesTags: ["DashboardTable"],
    }),
    getDashboardList: builder.query({
      query: (params) => {
        return {
          url: `/v1/dashboard/get-dashboard-list`,
          method: "GET",
          params,
        };
      },
    }),
  }),
});

export const {
  useGetAllDashboardQuery,
  useGetByIdDashboardQuery,
  useGetChartDataQuery,
  useGetDialDataQuery,
  useGetTableDataQuery,
  useGetDashboardListQuery,

  useLazyGetAllDashboardQuery,
  useLazyGetByIdDashboardQuery,
  useLazyGetChartDataQuery,
  useLazyGetDialDataQuery,
  useLazyGetTableDataQuery,
  useLazyGetDashboardListQuery,

  useCreateDashboardMutation,
  useUpdateDashboardMutation,
  useDeleteDashboardMutation,
} = dashboardApi;
